"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUB_MATCH_DATE_DIFF = void 0;
exports.SUB_MATCH_DATE_DIFF = 1 * 60 * 60; // value in seconds
//# sourceMappingURL=sub-match-date-diff.js.map